import { Divider } from 'antd';
import style from './ABStyles.module.css';

const legendItems = [
  {
    color: '#b6e0f2',
    value: '0% - 5%',
  },
  {
    color: '#b5d1f1',
    value: '5% - 10%',
  },
  {
    color: '#ffe5c7',
    value: '10% - 15%',
  },
  {
    color: '#1f5da4',
    value: '15% - 20%',
  },
  {
    color: '#002b5b',
    value: '20% - 25%',
  },
  {
    color: '#001a38',
    value: '25% - 50%',
  },
  {
    color: '#4d0006',
    value: '50% <',
  },
];

function AbLegend() {
  return (
    <div className={style.ab_legend}>
      <div>Легенда</div>
      <Divider style={{ margin: '5px 0' }} />
      <div className={style.legend_items_wrapper}>
        {legendItems.map((item, index) => {
          return (
            <div className={style.legend_item} key={`legend-${index}`}>
              <div
                style={{ background: item.color }}
                className={style.legend_color}
              />
              <div>{item.value}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AbLegend;
